import { lazy, Suspense } from 'react'
import DataTable from 'pages/dataTable'
import { Route, Routes } from 'react-router-dom'
import PrivateRoute from './PrivateRouter'
import Spinner from '../components/antD/spin'
import PublicRouter from './PublicRouter'

// 로그인
const Login = lazy(() => import('pages/login'))

// 강사전용
const TutorLogin = lazy(() => import('pages/tutor/login'))
const TutorSignup = lazy(() => import('pages/tutor/signup'))
const TutorFindPassword = lazy(() => import('pages/tutor/findPassword'))
const TutorMyPage = lazy(() => import('pages/tutor/myPage'))

// 메인
const Main = lazy(() => import('pages/main'))

// 교육실적
const Program = lazy(() => import('pages/program'))
const ProgramDetail = lazy(() => import('pages/program/detail'))
const ProgramEdit = lazy(() => import('pages/program/edit'))
const ProgramRegisterOne = lazy(() => import('pages/program/register/one'))
const ProgramRegisterBulk = lazy(() => import('pages/program/register/bulk'))

// 강사정보
const Tutors = lazy(() => import('pages/tutors'))
const TutorDetail = lazy(() => import('pages/tutors/detail'))
const TutorEdit = lazy(() => import('pages/tutors/edit'))
const TutorRegisterOne = lazy(() => import('pages/tutors/register/one'))
const TutorRegisterBulk = lazy(() => import('pages/tutors/register/bulk'))

// 월간보고
const Report = lazy(() => import('pages/report'))
const ReportDetail = lazy(() => import('pages/report/detail'))
const ReportRegister = lazy(() => import('pages/report/register'))
const ReportEdit = lazy(() => import('pages/report/edit'))

// 성과분석
const Statistics = lazy(() => import('pages/statistics'))
const TotalStatistics = lazy(() => import('pages/statistics/total'))

// 자산
const Tools = lazy(() => import('pages/tools/inventory'))
const ToolsDetail = lazy(() => import('pages/tools/inventory/detail'))
const ToolsEdit = lazy(() => import('pages/tools/inventory/edit'))
const ToolsInventoryRegisterOne = lazy(() => import('pages/tools/inventory/register/one'))
const ToolsInventoryRegisterBulk = lazy(() => import('pages/tools/inventory/register/bulk'))
const ToolsRental = lazy(() => import('pages/tools/rent'))
const ToolsRentalDetail = lazy(() => import('pages/tools/rent/detail'))
const ToolsRentEdit = lazy(() => import('pages/tools/rent/edit'))
const ToolsRentalRegisterBulk = lazy(() => import('pages/tools/rent/register/bulk'))
const RentalTransfer = lazy(() => import('pages/tools/transfer'))

// 수요조사
// const Survey = lazy(() => import('pages/survey'))
// const SurveyDetail = lazy(() => import('pages/survey/detail'))
// const SurveyRegister = lazy(() => import('pages/survey/register'))
// const SurveySubmit = lazy(() => import('pages/survey/submit'))
// const SurveyEdit = lazy(() => import('pages/survey/edit'))
// const SurveyResponse = lazy(() => import('pages/survey/response'))

// 업무지원
const Notice = lazy(() => import('pages/notice'))
const NoticeView = lazy(() => import('pages/notice/view'))
const NoticeWrite = lazy(() => import('pages/notice/write'))
const NoticeEdit = lazy(() => import('pages/notice/edit'))
const FAQ = lazy(() => import('pages/faq'))
const FAQView = lazy(() => import('pages/faq/view'))
const FAQWrite = lazy(() => import('pages/faq/write'))
const FAQEdit = lazy(() => import('pages/faq/edit'))
const Contact = lazy(() => import('pages/contact'))
const ContactView = lazy(() => import('pages/contact/view'))
const ContactWrite = lazy(() => import('pages/contact/write'))

// 계정관리
const AccountsPage = lazy(() => import('pages/accounts'))
const PasswordPage = lazy(() => import('pages/accounts/password'))

// DEV 전용
const PromptStudio = lazy(() => import('pages/dev/promptStudio'))

// etc
const RedirectPage = lazy(() => import('pages'))
const PageNotFound = lazy(() => import('pages/pageNotFound'))

const Router = () => {
    return (
        <Suspense fallback={<Spinner />}>
            <Routes>
                <Route element={<PublicRouter />}>
                    <Route path="/login" element={<Login />} />
                    <Route path="/tutor-login" element={<TutorLogin />} />
                    <Route path="/tutor-signup" element={<TutorSignup />} />
                    <Route path="/tutor-find-password" element={<TutorFindPassword />} />
                </Route>
                <Route element={<PrivateRoute />}>
                    <Route path="/main" element={<Main />} />
                    <Route path="/program" element={<Program />} />
                    <Route path="/program/:id" element={<ProgramDetail />} />
                    <Route path="/program/edit/:id" element={<ProgramEdit />} />
                    <Route path="/program/register/one" element={<ProgramRegisterOne />} />
                    <Route path="/program/register/bulk" element={<ProgramRegisterBulk />} />

                    <Route path="/tutors" element={<Tutors />} />
                    <Route path="/tutors/:id" element={<TutorDetail />} />
                    <Route path="/tutors/edit/:id" element={<TutorEdit />} />
                    <Route path="/tutors/register/one" element={<TutorRegisterOne />} />
                    <Route path="/tutors/register/bulk" element={<TutorRegisterBulk />} />

                    <Route path="/report" element={<Report />} />
                    <Route path="/report/:id" element={<ReportDetail />} />
                    <Route path="/report/edit/:id" element={<ReportEdit />} />
                    <Route path="/report/register" element={<ReportRegister />} />

                    <Route path="/statistics" element={<Statistics />} />
                    <Route path="/statistics/total" element={<TotalStatistics />} />

                    <Route path="/contact" element={<Contact />} />
                    <Route path="/contact/view/:id" element={<ContactView />} />
                    <Route path="/contact/write" element={<ContactWrite />} />

                    <Route path="/notice" element={<Notice />} />
                    <Route path="/notice/view/:id" element={<NoticeView />} />
                    <Route path="/notice/write" element={<NoticeWrite />} />
                    <Route path="/notice/edit/:id" element={<NoticeEdit />} />
                    <Route path="/contact/faq" element={<FAQ />} />
                    <Route path="/contact/faq/view/:id" element={<FAQView />} />
                    <Route path="/contact/faq/write" element={<FAQWrite />} />
                    <Route path="/contact/faq/edit/:id" element={<FAQEdit />} />

                    <Route path="/tools/inventory" element={<Tools />} />
                    <Route path="/tools/inventory/:id" element={<ToolsDetail />} />
                    <Route path="/tools/inventory/edit/:id" element={<ToolsEdit />} />
                    <Route path="/tools/inventory/register/one" element={<ToolsInventoryRegisterOne />} />
                    <Route path="/tools/inventory/register/bulk" element={<ToolsInventoryRegisterBulk />} />

                    <Route path="/tools/rental" element={<ToolsRental />} />
                    <Route path="/tools/rental/:id" element={<ToolsRentalDetail />} />
                    <Route path="/tools/rental/edit/:id" element={<ToolsRentEdit />} />
                    <Route path="/tools/rental/register/bulk" element={<ToolsRentalRegisterBulk />} />
                    <Route path="/tools/rental/transfer/:id" element={<RentalTransfer />} />

                    {/* <Route path="/survey" element={<Survey />} />
                    <Route path="/survey/:id" element={<SurveyDetail />} />
                    <Route path="/survey/edit/:id" element={<SurveyEdit />} />
                    <Route path="/survey/register" element={<SurveyRegister />} />
                    <Route path="/survey/submit/:id" element={<SurveySubmit />} />
                    <Route path="/survey/response/:id" element={<SurveyResponse />} /> */}

                    <Route path="/accounts" element={<AccountsPage />} />
                    <Route path="/accounts/password" element={<PasswordPage />} />

                    <Route path="/tutor-mypage" element={<TutorMyPage />} />

                    {(process.env.REACT_APP_ENVIRONMENT === 'dev' || process.env.REACT_APP_ENVIRONMENT === 'local') && (
                        <Route path="/dev/prompt-studio" element={<PromptStudio />} />
                    )}
                </Route>
                <Route path="/data-table/*" element={<DataTable />} />
                <Route path="/" element={<RedirectPage />} />
                <Route path="*" element={<PageNotFound />} />
            </Routes>
        </Suspense>
    )
}

export default Router
